import { Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { generateBkgSeatNewStyle } from '../../constant';
import { useSelector } from 'react-redux';
import SeatDeatils from '../../SeatDeatils/Index';
import SeatMenu from '../../SeatMenu';

const ChartBox = (props) => {
  const { bkgDeatails = {}, chartData = {}, chartScale = 1, id = '', selectedSeat = [], handleSelectedSeat = () => { }, handleSeatModDetails = () => { } } = props;
  const tableRef = useRef(null);
  const store = useSelector((store) => store);
  const { user } = store;
  const { userDetails } = user;
  const [tooltipOpen, setTooltipOpen] = useState(null);

  useEffect(() => {
    const handleMouseDown = (e) => {
      if (tableRef.current && !tableRef.current.contains(e.target)) {
        setTooltipOpen(null);
      }
    };

    document.addEventListener("mousedown", handleMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, []);
  return (
    <>
      <Box className='scrollBlueV6' sx={{
        padding: `10px 12px 10px ${20 * chartScale}px`,
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
        overflow: 'auto',
        height: '100%',
        width: '100%'
      }}
      >
        <center>
          <table id={id} ref={tableRef} style={{
            borderSpacing: `${3 * chartScale}px`,
            borderCollapse: 'separate',

          }}>
            <thead>
              <tr>
                {chartData?.lableList?.map((obj) => (
                  <th style={{
                    backgroundColor: obj.deck === 'Up' ? '#913214' : '#DD7858',
                    color: '#fff',
                    width: `${40 * chartScale}px`,
                    height: `${40 * chartScale}px`,
                    fontSize: `${14 * chartScale}px`,
                    fontWeight: 600,
                    fontStyle: 'SemiBold',
                    letterSpacing: '0%',
                    textTransform: 'uppercase',
                    textAlign: 'center'
                  }}>{obj.deck}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {
                Object.keys(chartData?.seatRowData || {})?.map((key, index) => {
                  return (
                    <>
                      <tr key={`tr-${index}-${key}`}>
                        {chartData?.seatRowData[key]?.map((obj) => {
                          return (
                            <SeatBox
                              obj={obj}
                              userDetails={userDetails}
                              chartScale={chartScale}
                              selectedSeat={selectedSeat}
                              handleSelectedSeat={handleSelectedSeat}
                              tooltipOpen={tooltipOpen}
                              setTooltipOpen={setTooltipOpen}
                              bkgDeatails={bkgDeatails}
                              handleSeatModDetails={handleSeatModDetails}

                            />
                          )
                        })}
                      </tr>
                    </>
                  )
                })}
            </tbody>
          </table>
        </center>
      </Box>
    </>
  )
}
const SeatBox = (props) => {
  const { obj, selectedSeat = [], chartScale = 1, handleSelectedSeat = () => { }, userDetails,
    tooltipOpen = null,
    setTooltipOpen = () => { },
    bkgDeatails = {},
    handleSeatModDetails = () => { }
  } = props;

  const targetRef = useRef()
  const [seatInfoDrop, setSeatInfoDrop] = useState(false)

  const handleRightClick = (event) => {
    event.preventDefault(); // Prevent default context menu
    if (obj.IsBkgAvailable === 0 && obj.ForAgentID === userDetails?.AgentID) {
      setSeatInfoDrop(true)
    }
  }
  let alreadySeat = selectedSeat.filter((item) => item.SeatLabel === obj.SeatLabel)



  const Seat = () => (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'start', padding: '0px 2px 2px 0px' }}>
      <div style={{ position: 'absolute' }}>
      </div>
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', flex: 1, justifyContent: 'center' }}>
        {
          obj.IsAisle ? null :
            obj.IsBkgAvailable === 0 ?
              <div style={{ textAlign: 'center' }}>
                <div>{obj.SeatLabel}</div>
                {(obj.IsAvailable === 0 && obj.Gender === 'F') &&
                  <div style={{ fontSize: `${12 * chartScale}px` }}>{`(${obj.Gender})`}</div>
                }
              </div>
              :
              <div style={{ textAlign: 'center' }}>
                <div>{obj.SeatLabel}</div>
                {(obj.IsAvailable === 0 && obj.Gender === 'F') &&
                  <div style={{ fontSize: `${12 * chartScale}px` }}>{`(${obj.Gender})`}</div>
                }
                {!(obj.IsAvailable === 0 && obj.IsAisle !== 1) &&
                  <div style={{ fontSize: `${10 * chartScale}px` }}>{alreadySeat.length > 0 ? obj.baseFare : obj.orgBaseFare}</div>
                }
              </div>
        }
      </div>
    </div>
  )


  let enableTooltip = obj.ForAgentID === userDetails?.AgentID && obj.IsBkgAvailable === 0
  return (
    <td
      key={`seatBox-${obj?.RowNo}-${obj?.ColumnNo}-${obj?.SeatLabel}`}
      rowspan={obj.Height}
      colspan={obj.Width}
      ref={targetRef}
      style={{ ...generateBkgSeatNewStyle(obj, alreadySeat.length > 0, userDetails, chartScale) }}
      onClick={() => {
        handleSelectedSeat(obj)
      }}
      className={obj.ForAgentID === userDetails?.AgentID ? "SeatblinkBorder" : ''}
    >
      {seatInfoDrop ?
        <SeatMenu
          obj={obj}
          userDetails={userDetails}
          seatInfoDrop={seatInfoDrop}
          setSeatInfoDrop={setSeatInfoDrop}
          setTooltipOpen={setTooltipOpen}
          bkgDeatails={bkgDeatails}
          handleSeatModDetails={handleSeatModDetails}
        >
          <span>
            <Seat />
          </span>
        </SeatMenu>
        :
        <SeatDeatils
          obj={obj}
          userDetails={userDetails}
          tooltipOpen={tooltipOpen}
          setTooltipOpen={setTooltipOpen}
          targetRef={targetRef}
        >
          <span
            onContextMenu={handleRightClick}
            onMouseEnter={() => {
              if (enableTooltip) {
                setTooltipOpen(obj?.SeatLabel)
              }
            }}
            onMouseLeave={() => setTooltipOpen(null)}
            style={{ width: '100%', height: '100%' }}
          >
            <Seat />
          </span>
        </SeatDeatils>
      }
    </td >
  )
}



export default ChartBox